import { BaseResponse } from './client-response';

export class SuccessResponse<T> extends BaseResponse<T> {
  constructor(body: T) {
    super(true, body);
  }
}
